module.exports = __webpack_public_path__ + "img/IT0001447340439.d71e6fce.png";